import { createContext } from 'react';

export const ApolloContext = createContext({});
